<div>
    <ngx-create-raise-request [id]="RrId"></ngx-create-raise-request>
</div>